import React, { useEffect, useState } from "react";

import AssessmentDataService from "../../services/Assessment";
import {
  AllStates,
  Budget,
  EducationalQualifications,
  FitnessOptions,
  GenderOptions,
  Issues,
  LengthOfConcern,
  OccupationType,
  PreferedLanguage,
  RelationshipStatus,
  SuggestedExperts,
  SuggestedTherapyType,
  TherapistAgeGroup,
  TheraputicHistory,
  TherapyDeliveryMode,
  UrgencyOfIntervention,
  YesNoOptions,
} from "../../Config/AddAssessmentOptions";
import { MultiSelect } from "react-multi-select-component";
import { useNavigate, useParams } from "react-router-dom";
import {
  assessmentData,
  updateAssessmentData,
} from "../../Config/AsessmentData";
import {
  lead_status,
  old_lead_status,
  new_lead_status,
} from "../../Config/leadStatus";
import { ehcExpert } from "../../Config/ehcExpert";
import { useToast } from "@chakra-ui/react";
import { convertToArray } from "../../Config/functions";
import Select from "react-select";
import { DateTime } from "luxon";

export const EditAssessments = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const user = localStorage.getItem("logged_in_User");
  const ehcPage = localStorage.getItem("ehc_page");
  const leadStatusOptions =
    ehcPage === "old" ? old_lead_status : new_lead_status;
  const toast = useToast();
  const navigate = useNavigate();
  const { id } = useParams();
  const [bookingDetails, setBookingDetails] = useState<any>({
    booking_date: "",
    booking_time: "",
    booking_expert: "",
    subscription_amount: "",
    booking_amount: "",
  });
  const [sessionHistory, setSessionHistory] = useState<any>({
    session_date: "",
    session_time: "",
    session_expert: "",
  });
  const [therapyMode, setTherapyMode] = useState<any>("");
  const [therapyType, setTherapytype] = useState<any>("");
  const [assessment, setAssessment] = useState<any>(assessmentData);
  const [theraputicHistory, setTheraputicHistory] = useState<any>("");
  const [selected, setSelected] = useState<any>([]);
  const [language, setLanguage] = useState<any>([]);

  const isExpertAssigned =
    ehcPage !== "old" && assessment.new_lead_status === "EXPERT_ASSIGNED";

  const handleBookingDetails = (e: any) => {
    setBookingDetails({ ...bookingDetails, [e.target.name]: e.target.value });
  };
  const handleTheraputicHistory = (e: any) => {
    setTheraputicHistory(e.target.value);
  };
  const handleChange = (e: any) => {
    setAssessment({
      ...assessment,
      [e.target.name]: e.target.value,
    });
  };
  const handleSessionChange = (e: any) => {
    setSessionHistory({ ...sessionHistory, [e.target.name]: e.target.value });
  };
  const handleDataChange = () => {
    let dateTime: any = "";

    if (assessment.date && assessment.time) {
      const dt = DateTime.fromFormat(
        `${assessment.date} ${assessment.time}`,
        "yyyy-LL-dd HH:mm",
        { zone: "Asia/Kolkata" }
      );

      dateTime = dt.toUTC().toJSDate();
      // const isoString = `${assessment.date}T${assessment.time}:00Z`;
      // dateTime = new Date(isoString);
    }

    // console.log(dateTime);

    setAssessment({
      ...assessment,
      date_time: dateTime,
      booking_entry:
        assessment.booking_entry != null
          ? bookingDetails.booking_date != ""
            ? [bookingDetails, ...assessment.booking_entry]
            : [...assessment.booking_entry]
          : [bookingDetails],
      types_of_theraputic_history:
        theraputicHistory != "" ? [theraputicHistory] : [],
      therapy_type: therapyType != "" ? [therapyType] : [],
      therapy_delivery_modes: therapyMode != "" ? [therapyMode] : [],
      languages: language.map((el: any) => el.value),
      issues: selected.map((el: any) => el.value),
    });
  };
  const handleSubmit = () => {
    if (isExpertAssigned) {
      const requiredFields = [
        { key: "name", label: "Name" },
        { key: "email", label: "Email" },
        { key: "phone", label: "Phone" },
        { key: "age", label: "Age" },
        { key: "gender", label: "Gender" },
        { key: "state", label: "State" },
        { key: "city", label: "City" },
        { key: "budget", label: "Budget" },
        { key: "student", label: "Student" },
        { key: "educational_qualification", label: "Educational Qualification" },
        { key: "relationship_status", label: "Relationship Status" },
        { key: "dependents", label: "Dependents" },
        { key: "occupation", label: "Occupation" },
        { key: "occupation_type", label: "Occupation Type" },
        { key: "family_mental_history", label: "Family Mental Health History" },
      ];
      const missingFields = requiredFields.filter(
        (f) => !assessment[f.key] || assessment[f.key] === ""
      );
      if (missingFields.length > 0) {
        toast({
          position: "top",
          title: "Required Fields Missing",
          description: `Please fill: ${missingFields.map((f) => f.label).join(", ")}`,
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        return;
      }
    }
    AssessmentDataService.update(
      {
        ...assessment,
        session_history:
          sessionHistory.session_date != ""
            ? [sessionHistory, ...assessment.session_history]
            : [...assessment.session_history],
        booking_entry:
          bookingDetails.booking_date != ""
            ? [bookingDetails, ...assessment.booking_entry]
            : [...assessment.booking_entry],
      },
      id,
      token
    )
      .then((response: any) => {
        navigate(`/freeconsultation/view/${id}`);
      })
      .catch((e: Error) => {
        console.log(e);
      });
  };
  useEffect(() => {
    handleDataChange();
  }, [
    bookingDetails,
    language,
    selected,
    theraputicHistory,
    therapyMode,
    therapyType,
    assessment.date,
    assessment.time,
  ]);
  useEffect(() => {
    AssessmentDataService.get(String(id), token)
      .then((res) => {
        const data = res.data;
        const result = data.data;
        setAssessment(updateAssessmentData(result));
        result.client_information.languages_known != null
          ? setLanguage(
              convertToArray(result.client_information.languages_known)
            )
          : setLanguage([]);
        setSelected(
          Issues.filter((issue) =>
            result.screening_information.issues.includes(issue.value)
          )
        );
        result.screening_information.types_of_theraputic_history &&
        result.screening_information.types_of_theraputic_history != null &&
        result.screening_information.types_of_theraputic_history.length > 0
          ? setTheraputicHistory(
              result.screening_information.types_of_theraputic_history[0]
            )
          : setTheraputicHistory("");
        result.treatment_preferences.therapy_delivery_modes &&
        result.treatment_preferences.therapy_delivery_modes != null &&
        result.treatment_preferences.therapy_delivery_modes.length > 0
          ? setTherapyMode(
              result.treatment_preferences.therapy_delivery_modes[0]
            )
          : setTherapyMode("");
        result.treatment_preferences.therapy_type &&
        result.treatment_preferences.therapy_type != null &&
        result.treatment_preferences.therapy_type.length > 0
          ? setTherapytype(result.treatment_preferences.therapy_type[0])
          : setTherapytype("");
      })
      .catch((e) => {
        if (e.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 500);
        }
        console.log(e);
      });
  }, []);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Free Consultation</div>
      <div className=" p-5">
        {/* top section */}
        <div className="row m-0 justify-content-center">
          <div className="card p-5 col-lg-10">
            <h4 className="mb-3">EHC Information</h4>
            <form className="add_assesment_form">
              <div className="form-row">
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_date">
                    Date
                  </label>
                  <input
                    value={assessment.date}
                    onChange={handleChange}
                    type="date"
                    className="form-control"
                    id="booking_date"
                    name="date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="booking_time">
                    Time (24H Format)
                  </label>
                  <input
                    value={assessment.time}
                    onChange={handleChange}
                    type="time"
                    className="form-control"
                    id="booking_time"
                    name="time"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Lead Status*
                  </label>
                  <select
                    value={
                      ehcPage === "old"
                        ? assessment.lead_status
                        : assessment.new_lead_status
                    }
                    className="form-control"
                    name={ehcPage === "old" ? "lead_status" : "new_lead_status"}
                    onChange={handleChange}
                  >
                    {leadStatusOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Lead Origin
                  </label>
                  <select
                    defaultValue={"EHC"}
                    value={assessment.lead_origin}
                    className="form-control"
                    name="lead_origin"
                    onChange={handleChange}
                  >
                    <option value="">Select Lead Origin </option>
                    <option value="EHC">EHC</option>
                    <option value="AESS">AESS</option>
                    <option value="WIX">Wix</option>
                    <option value="DEV_APP">Dev App</option>
                    <option value="APP">App</option>
                    <option value="APP_CALL">App Call</option>
                    <option value="APP_CHAT">App Chat</option>
                    <option value="OTHER">Other</option>
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="expert">
                    Ehc Expert
                  </label>
                  <select
                    value={assessment.expert}
                    className="form-control"
                    id="expert"
                    name="expert"
                    onChange={handleChange}
                  >
                    {ehcExpert
                      .filter((el: any) => el.value !== "test1_manisha")
                      .map((el: any) => (
                        <option value={el.value}>{el.name}</option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mb-3 mt-4">
                  <h4>Service Booking Date & Time</h4>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Date
                  </label>
                  <input
                    value={assessment.service_booking_date}
                    onChange={handleChange}
                    type="date"
                    className="form-control"
                    id="service_booking_date"
                    name="service_booking_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="service_booking_time">
                    Time (24H Format)
                  </label>
                  <input
                    value={assessment.service_booking_time}
                    onChange={handleChange}
                    type="time"
                    className="form-control"
                    id="service_booking_time"
                    name="service_booking_time"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mb-3 mt-4">
                  <h4>Lead Information{isExpertAssigned && "*"}</h4>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Name*
                  </label>
                  <input
                    value={assessment.name}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="service_booking_name"
                    name="name"
                    required={isExpertAssigned}
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_email">
                    Email*
                  </label>
                  <input
                    value={assessment.email}
                    onChange={handleChange}
                    type="email"
                    className="form-control"
                    id="service_booking_email"
                    name="email"
                    required={isExpertAssigned}
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_phone">
                    Phone*
                  </label>
                  <input
                    value={assessment.phone}
                    onChange={handleChange}
                    type="phone"
                    className="form-control"
                    id="service_booking_phone"
                    name="phone"
                    required={isExpertAssigned}
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="service_booking_date">
                    Age
                  </label>
                  <input
                    value={assessment.age}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="service_booking_name"
                    name="age"
                    required={isExpertAssigned}
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="gender">
                    Gender
                  </label>
                  <select
                    value={assessment.gender}
                    className="form-control"
                    id="gender"
                    name="gender"
                    onChange={handleChange}
                    required={isExpertAssigned}
                  >
                    {GenderOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="state">
                    State
                  </label>
                  <select
                    value={assessment.state}
                    className="form-control"
                    name="state"
                    id="state"
                    onChange={handleChange}
                    required={isExpertAssigned}
                  >
                    {AllStates.map((el: any) => (
                      <option value={el.value}>{el.state}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="city">
                    City
                  </label>
                  <input
                    value={assessment.city}
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                    onChange={handleChange}
                    required={isExpertAssigned}
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="budget">
                    Budget
                  </label>
                  <select
                    className="form-control"
                    name="budget"
                    id="budget"
                    value={assessment.budget}
                    onChange={handleChange}
                    required={isExpertAssigned}
                  >
                    {Budget.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="student">
                    Student
                  </label>
                  <select
                    value={assessment.student}
                    className="form-control"
                    name="student"
                    id="student"
                    onChange={handleChange}
                    required={isExpertAssigned}
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label
                    className="form-label"
                    htmlFor="educational_qualification"
                  >
                    Educational Qualification
                  </label>
                  <select
                    value={assessment.educational_qualification}
                    onChange={handleChange}
                    className="form-control"
                    name="educational_qualification"
                    id="educational_qualification"
                    required={isExpertAssigned}
                  >
                    {EducationalQualifications.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="relationship_status">
                    Relationship Status
                  </label>
                  <select
                    value={assessment.relationship_status}
                    onChange={handleChange}
                    className="form-control"
                    name="relationship_status"
                    id="relationship_status"
                    required={isExpertAssigned}
                  >
                    {RelationshipStatus.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="dependents">
                    Dependents
                  </label>
                  <select
                    value={assessment.dependents}
                    onChange={handleChange}
                    className="form-control"
                    name="dependents"
                    id="dependents"
                    required={isExpertAssigned}
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="occupation">
                    Occupation
                  </label>

                  <input
                    value={assessment.occupation}
                    onChange={handleChange}
                    type="text"
                    className="form-control"
                    id="occupation"
                    name="occupation"
                    required={isExpertAssigned}
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="occupation_type">
                    Occupation Type
                  </label>
                  <select
                    value={assessment.occupation_type}
                    onChange={handleChange}
                    className="form-control"
                    name="occupation_type"
                    id="occupation_type"
                    required={isExpertAssigned}
                  >
                    {OccupationType.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="family-health-histroy">
                    Family Mental Health Histroy
                  </label>
                  <select
                    value={assessment.family_mental_history}
                    onChange={handleChange}
                    className="form-control"
                    name="family_mental_history"
                    id="family-health-histroy"
                    required={isExpertAssigned}
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Psychological Information</h4>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="issues*">
                    Issues
                  </label>
                  <MultiSelect
                    options={Issues}
                    // className="form-control"
                    labelledBy="Select Issues"
                    value={selected}
                    onChange={setSelected}
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="symptoms">
                    Other Symptoms
                  </label>
                  <input
                    onChange={handleChange}
                    value={assessment.symptoms}
                    type="text"
                    className="form-control"
                    id="symptoms"
                    name="symptoms"
                  />
                </div>
                <div className=" col-md-4 mb-4 form-group">
                  <label className="form-label" htmlFor="length_of_concern">
                    Length Of Concern
                  </label>
                  <select
                    value={assessment.length_of_concern}
                    onChange={handleChange}
                    className="form-control"
                    name="length_of_concern"
                    id="length_of_concern"
                  >
                    {LengthOfConcern.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label className="form-label" htmlFor="frequency_of_symptoms">
                    Frequency Of Symptoms
                  </label>
                  <select
                    value={assessment.frequency_of_symptoms}
                    onChange={handleChange}
                    className="form-control"
                    name="frequency_of_symptoms"
                    id="frequency_of_symptoms"
                  >
                    <option value="">Select If Applicable</option>
                    <option value="sometimes">Sometimes</option>
                    <option value="often">Often</option>
                    <option value="always">Always</option>
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label
                    className="form-label"
                    htmlFor="therapeutic_edication_istory"
                  >
                    Therapeutic Medication History
                  </label>
                  <select
                    value={assessment.medication_history}
                    onChange={handleChange}
                    className="form-control"
                    name="medication_history"
                    id="therapeutic_edication_istory"
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="therapeutic_histroy">
                    Therapeutic Histroy
                  </label>
                  <select
                    value={assessment.therapeutic_histroy}
                    onChange={handleChange}
                    className="form-control"
                    name="therapeutic_histroy"
                    id="therapeutic_histroy"
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label
                    className="form-label"
                    htmlFor="types-of-theraputic-history"
                  >
                    Types of Theraputic History
                  </label>
                  <select
                    value={theraputicHistory}
                    onChange={handleTheraputicHistory}
                    className="form-control"
                    name="types_of_theraputic_history"
                    id="types-of-theraputic-history"
                  >
                    {TheraputicHistory.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label
                    className="form-label"
                    htmlFor="urgency_of_intervention"
                  >
                    Urgency of Intervention
                  </label>
                  <select
                    value={assessment.urgency_of_intervention}
                    onChange={handleChange}
                    className="form-control"
                    name="urgency_of_intervention"
                    id="urgency_of_intervention"
                  >
                    {UrgencyOfIntervention.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label
                    className="form-label"
                    htmlFor="current_physical_fitness"
                  >
                    Current Physical Fitness
                  </label>
                  <select
                    value={assessment.current_physical_fitness}
                    onChange={handleChange}
                    className="form-control"
                    name="current_physical_fitness"
                    id="Current_physical_health"
                  >
                    {FitnessOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="physical_pain">
                    Physical Pain
                  </label>
                  <select
                    value={assessment.physical_pain}
                    onChange={handleChange}
                    className="form-control"
                    name="physical_pain"
                    id="physical_pain"
                  >
                    {YesNoOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group  col-md-6 mb-4">
                  <label className="form-label" htmlFor="suggest_therapy_type">
                    Reason Of Interest
                  </label>
                  <textarea
                    value={assessment.reason_for_interest}
                    onChange={handleChange}
                    className="form-control"
                    id="reason_for_interest"
                    name="reason_for_interest"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label className="form-label" htmlFor="suggest_therapy_type">
                    Health Problems
                  </label>
                  <textarea
                    value={assessment.health_problems}
                    onChange={handleChange}
                    className="form-control"
                    id="Health_problems"
                    name="health_problems"
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Expert Preferences</h4>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="gender_of_therapist">
                    Gender of Therapist
                  </label>
                  <select
                    value={assessment.gender_of_therapist}
                    onChange={handleChange}
                    className="form-control"
                    name="gender_of_therapist"
                    id="gender_of_therapist"
                  >
                    {GenderOptions.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="age_group_of_therapist">
                    Age Group of Therapist
                  </label>
                  <select
                    value={assessment.age_group_of_therapist}
                    onChange={handleChange}
                    className="form-control"
                    name="age_group_of_therapist"
                    id="age_group_of_therapist"
                  >
                    {TherapistAgeGroup.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Therapy Preferences</h4>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="therapy-delivery-mode">
                    Therapy Delivery Mode
                  </label>
                  <select
                    value={therapyMode}
                    onChange={(e: any) => setTherapyMode(e.target.value)}
                    className="form-control"
                    name="therapy_delivery_modes"
                    id="therapy-delivery-mode"
                  >
                    {TherapyDeliveryMode.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="therapy-type">Therapy Type</label>
                  <select
                    value={therapyType}
                    onChange={(e: any) => setTherapytype(e.target.value)}
                    className="form-control"
                    name="therapy_type"
                    id="therapy-type"
                  >
                    {SuggestedTherapyType.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="preferred_language">Preferred Language</label>
                  <MultiSelect
                    options={PreferedLanguage}
                    // className="form-control"
                    labelledBy="Select Languages"
                    value={language}
                    onChange={setLanguage}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>EHC Screening Result</h4>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="suggested_expert_name1">
                    Suggested Expert Name 1
                  </label>
                  <Select
                    id="c"
                    name="suggested_expert_name1"
                    options={SuggestedExperts}
                    placeholder="Choose Expert"
                    isClearable
                    value={SuggestedExperts.find(
                      (option: any) =>
                        option.value === assessment.suggested_expert_name1
                    )}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: "suggested_expert_name1",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="suggested_expert_name2">
                    Suggested Expert Name 2
                  </label>
                  <Select
                    id="c"
                    name="suggested_expert_name2"
                    options={SuggestedExperts}
                    placeholder="Choose Expert"
                    isClearable
                    required
                    value={SuggestedExperts.find(
                      (option: any) =>
                        option.value === assessment.suggested_expert_name2
                    )}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: "suggested_expert_name2",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="suggested_expert_name3">
                    Suggested Expert Name 3
                  </label>
                  <Select
                    id="c"
                    name="suggested_expert_name3"
                    options={SuggestedExperts}
                    placeholder="Choose Expert"
                    isClearable
                    required
                    value={SuggestedExperts.find(
                      (option: any) =>
                        option.value === assessment.suggested_expert_name3
                    )}
                    onChange={(selectedOption) =>
                      handleChange({
                        target: {
                          name: "suggested_expert_name3",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    classNamePrefix="react-select"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="suggest_therapy_type">
                    Suggested Therapy Type
                  </label>
                  <select
                    value={assessment.suggest_therapy_type}
                    onChange={handleChange}
                    className="form-control"
                    name="suggest_therapy_type"
                    required
                    id="suggest_therapy_type"
                  >
                    {SuggestedTherapyType.map((el: any) => (
                      <option value={el.value}>{el.data}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Notes</h4>
                </div>
                <div className="form-group col-md-12 mb-4 pl-0">
                  <textarea
                    value={assessment.notes}
                    onChange={handleChange}
                    className="form-control"
                    id="notes"
                    required
                    name="notes"
                  ></textarea>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>EHC Followup Notes</h4>
                </div>
                <div className="form-group col-md-12 mb-4 pl-0">
                  <textarea
                    value={assessment.ehc_followup_notes}
                    onChange={handleChange}
                    className="form-control"
                    id="ehc_followup_notes"
                    required
                    name="ehc_followup_notes"
                  ></textarea>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Booking Information</h4>
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="booking_date">
                    {" "}
                    Booking Date (24H Format)
                  </label>
                  <input
                    onChange={handleBookingDetails}
                    type="date"
                    className="form-control"
                    id="booking_date"
                    required
                    name="booking_date"
                  />
                </div>
                <div className="form-group col-md-6 mb-4">
                  <label htmlFor="booking_time">
                    {" "}
                    Booking Time (24H Format)
                  </label>
                  <input
                    onChange={handleBookingDetails}
                    type="time"
                    className="form-control"
                    id="booking_time"
                    required
                    name="booking_time"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="booking_amount"> Booking Amount </label>
                  <input
                    onChange={handleBookingDetails}
                    type="text"
                    className="form-control"
                    id="booking_amount"
                    required
                    name="booking_amount"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="subscription_amount">
                    Subscription Amount
                  </label>
                  <input
                    onChange={handleBookingDetails}
                    type="text"
                    className="form-control"
                    id="subscription_amount"
                    required
                    name="subscription_amount"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="booking_expert">Select Booking Expert</label>
                  <select
                    onChange={handleBookingDetails}
                    className="form-control"
                    name="booking_expert"
                    required
                    id="booking_expert"
                  >
                    {SuggestedExperts.map((el: any) => (
                      <option value={el.value}>{el.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="col-md-12 mt-4 mb-3">
                  <h4>Session Information</h4>
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="session_date"> Session Date</label>
                  <input
                    onChange={handleSessionChange}
                    type="date"
                    className="form-control"
                    id="session_date"
                    required
                    name="session_date"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="session_time"> Session Time</label>
                  <input
                    onChange={handleSessionChange}
                    type="time"
                    className="form-control"
                    id="session_time"
                    required
                    name="session_time"
                  />
                </div>
                <div className="form-group col-md-4 mb-4">
                  <label htmlFor="session_expert">Select Session Expert</label>
                  <select
                    onChange={handleSessionChange}
                    className="form-control"
                    name="session_expert"
                    required
                    id="session_expert"
                  >
                    {SuggestedExperts.map((el: any) => (
                      <option value={el.value}>{el.label}</option>
                    ))}
                  </select>
                </div>
              </div>
              <button
                type="submit"
                className="btn action-btn mt-3 px-5 submit-button"
                onClick={handleSubmit}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
